// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudUploadOutlinedSvg from "@ant-design/icons-svg/es/asn/CloudUploadOutlined";
import AntdIcon from '../components/AntdIcon';

var CloudUploadOutlined = function CloudUploadOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudUploadOutlinedSvg
  }));
};

CloudUploadOutlined.displayName = 'CloudUploadOutlined';
export default React.forwardRef(CloudUploadOutlined);